import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { PresentationProvider } from "./components/PresentationModal";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Capabilities from "./pages/Capabilities";
import AdminLeads from "./pages/AdminLeads";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <PresentationProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacidad" element={<Privacy />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/capacidades" element={<Capabilities />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
            </Routes>
          </PresentationProvider>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#121214",
              border: "1px solid rgba(212, 175, 55, 0.3)",
              color: "#F4F4F5",
              borderRadius: 0,
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
